import axios from 'axios'
import Cookies from 'js-cookie'
import * as util from './util'
import { hideLoading } from '../utils/loading.js'
import { $BASE_URL } from './env'

console.log('当前环境：' + process.env.NODE_ENV)

const service = axios.create({
  withCredentials: true,
  timeout: 10 * 1000,
})

service.defaults.baseURL = $BASE_URL

service.interceptors.request.use(
  config => {
    config.headers.Accept = 'application/json'
    if (Cookies.get('XSRF-TOKEN')) {
      config.headers['X-XSRF-TOKEN'] = Cookies.get('XSRF-TOKEN')
    }
    return config
  },
  error => {
    util.showTips('请求超时!')
    return Promise.reject(error)
  },
)

service.interceptors.response.use(
  response => {
    const res = response.data
    hideLoading()
    if (res.code == 200) {
      return res
    } else {
      if (![401, 402,407,400].includes(res.code)) {
        // 订单轮询接口不提示
        util.showTips(res.status);
      }
      if(!['/user/info'].includes(response.config.url) && window.location.href.indexOf('paperFrontend/paperEdit') > -1 && res.code == 401) {
        util.locatioanToLogin(res);
      }
      return Promise.reject(res)
    }
  },
  error => {
    hideLoading()
    let errMsg = ''
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          errMsg = '请求错误(400)'
          break
        case 401:
          errMsg = '未授权，请重新登录(401)'
          break
        case 403:
          errMsg = '拒绝访问(403)'
          break
        case 404:
          errMsg = '请求出错(404)'
          break
        case 408:
          errMsg = '请求超时(408)'
          break
        case 500:
          errMsg = '服务器错误(500)'
          break
        case 501:
          errMsg = '服务未实现(501)'
          break
        case 502:
          errMsg = '网络错误(502)'
          break
        case 503:
          errMsg = '服务不可用(503)'
          break
        case 504:
          errMsg = '网络超时(504)'
          break
        case 505:
          errMsg = 'HTTP版本不受支持(505)'
          break
        default:
          errMsg = `连接出错(${error.response.status})!`
      }
    } else {
      errMsg = '连接服务器失败!'
    }
    if (error && error.response && error.response.status != 401) {
      util.showTips(errMsg)
    }
    if (error && error.response) {
      return Promise.reject(error)
    } else {
      return { data: {} } // 返回一个空对象，主要是防止控制台报错
    }
  },
)

export default service
